import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formatCurrency as formatCurrencyBase } from '../utils/currencyUtils';
import {
  getDecimalLayout,
  getDecimalLayoutLocale,
  formatNumberWithDecimalLayout,
  formatAmountInputValue,
  parseAmountInputValue,
} from '../utils/userPreferencesHelpers';

export function useNumberFormat() {
  const preferences = useSelector((state) => state.user.preferences);
  const decimalLayout = getDecimalLayout(preferences);
  const locale = getDecimalLayoutLocale(preferences);

  return useMemo(
    () => ({
      preferences,
      decimalLayout,
      locale,
      formatNumber: (value, options) => formatNumberWithDecimalLayout(value, preferences, options),
      formatCurrency: (amount, currencyCode) => formatCurrencyBase(amount, currencyCode, preferences),
      formatAmountInput: (value) => formatAmountInputValue(value, preferences),
      parseAmount: (value) => parseAmountInputValue(value, preferences),
    }),
    [preferences, decimalLayout, locale],
  );
}
